import { useIntl } from 'react-intl';
import BlockDataForm from '@plone/volto/components/manage/Form/BlockDataForm';
import SidebarPortal from '@plone/volto/components/manage/Sidebar/SidebarPortal';
import HeroBannerSchema from './schema';
import HeroBannerBody from './HeroBannerBody';
import type { HeroBannerData } from './HeroBannerBody';

type HeroBannerEditProps = {
  data: HeroBannerData;
  block: string;
  selected: boolean;
  onChangeBlock: (block: string, data: HeroBannerData) => void;
};

const HeroBannerEdit = (props: HeroBannerEditProps) => {
  const { data, block, onChangeBlock, selected } = props;
  const intl = useIntl();
  const schema = HeroBannerSchema({ intl });

  return (
    <>
      <HeroBannerBody data={data} isEditMode />
      <SidebarPortal selected={selected}>
        <BlockDataForm
          schema={schema}
          title={schema.title}
          onChangeField={(id: string, value: unknown) => {
            onChangeBlock(block, { ...data, [id]: value });
          }}
          formData={data}
          block={block}
        />
      </SidebarPortal>
    </>
  );
};

export default HeroBannerEdit;
